// extracted by mini-css-extract-plugin
module.exports = {"card":"TutorialCard_card__Zh8SX","cardImg":"TutorialCard_cardImg__2AHev","titleText":"TutorialCard_titleText__1eotU"};